module.exports = __webpack_public_path__ + "img/horizontal_6_6_3.e0d03fc7.png";